<template>
  <div class="mian_view">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <div class="main">
      <h3>新建任务</h3>
      <div class="progress">
        <div class="progress_item">
          <div :class="active == 0 ? 'selected' : ''">1</div>
          <p>任务信息</p>
        </div>
        <div class="divider"></div>
        <div class="progress_item">
          <div :class="active == 1 ? 'selected' : ''">2</div>
          <p>选择视频</p>
        </div>
        <div class="divider"></div>
        <div class="progress_item">
          <div :class="active == 2 ? 'selected' : ''">3</div>
          <p>选择学员</p>
        </div>
      </div>
      <div class="title">
        <h3>{{ titleText() }}</h3>
        <div></div>
      </div>
      <!-- 主题内容 -->
      <div class="task_info" v-if="active == 0">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="任务名称：" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="任务简介：">
            <el-input
              type="textarea"
              placeholder="请输入任务简介"
              v-model="ruleForm.intro"
              maxlength="30"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item label="任务有效期：" prop="isIndate">
            <div class="time_view">
              <el-radio-group v-model="ruleForm.isIndate">
                <el-radio :label="0">无限制</el-radio>
                <el-radio :label="1">设定有效期</el-radio>
              </el-radio-group>
              <el-date-picker
                v-if="ruleForm.isIndate == 1"
                v-model="viewTime"
                :picker-options="pickerOptions"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="是否必学：" prop="isMust">
            <div>
              <p class="t">必学课程将表示必学并置顶于学员学习任务列表</p>
              <el-radio-group v-model="ruleForm.isMust">
                <el-radio :label="0">必学</el-radio>
                <el-radio :label="1">非必学</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              type="textarea"
              placeholder="请输入备注"
              v-model="ruleForm.remark"
              maxlength="150"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 第二步 -->
      <CascadePage
        v-else-if="active == 1"
        :key="active"
        ref="cascade"
        :videoArr="videoArr"
      />
      <!-- 第三步 -->
      <Candidate
        v-else-if="active == 2"
        ref="candidate"
        :editData="editType == true ? list_vip : 'null'"
      />
    </div>
    <div class="button_view fixed">
      <el-button @click="previousStep(0)">{{
        active == 0 ? "取消" : "上一步"
      }}</el-button>
      <el-button :loading="loading" @click="previousStep(1, 'ruleForm')">{{
        active == 2 ? "完成" : "下一步"
      }}</el-button>
    </div>
  </div>
</template>

<script>
import CascadePage from "./CascadePage.vue";
import Candidate from "../../../components/addCandidate/Candidate.vue";
import taskApi from "@/api/videoTask";
import loginvuex from "@/store/index";

export default {
  data() {
    return {
      active: 0,
      title: "任务信息",
      loading: false,
      ruleForm: {
        name: "",
        intro: "",
        isIndate: 0, // 是否设置有效期（1是，0否）为1 时需要传beginTime和endTime
        isMust: 0,
        remark: "", // 备注
      },
      viewTime: [], // 时间
      videoArr: [],
      types: 0,
      editType: false, // 编辑状态
      list_vip: [], // 新定义的数组
      examineeData: [], // 考生数组
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        isIndate: [
          { required: true, message: "请选择任务有效期", trigger: "change" },
        ],
        isMust: [
          { required: true, message: "请选择是否必学", trigger: "change" },
        ],
      },
    };
  },
  props: ["cutcoms"],
  components: {
    CascadePage,
    Candidate,
  },
  activated() {
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    // 返回按键
    backBtn() {
      this.$destroy();
      this.cutcoms(0);
    },
    async init() {
      this.active = 0;
      this.list_vip = [];
      this.viewTime = [];
      console.log(this.$parent.stateType);
      if (this.$parent.stateType == 0) {
        // 添加
        this.ruleForm = {
          name: "",
          intro: "",
          isIndate: 0, // 是否设置有效期（1是，0否）为1 时需要传beginTime和endTime
          isMust: 0,
          remark: "", // 备注
        };
        this.types = 1; // 新增状态
      } else {
        // 编辑
        this.types = 2; // 编辑状态
        const obj = {
          taskID: this.$parent.rowObj.taskId,
          hid: JSON.parse(loginvuex.state.userlist).hid,
        };
        const { data } = await taskApi.getTaskConfig(obj);
        if (data.Status == 200) {
          this.ruleForm.name = data.Data.taskConfig.name;
          this.ruleForm.intro = data.Data.taskConfig.Intro;
          this.ruleForm.isIndate = data.Data.taskConfig.IsIndate;
          this.ruleForm.isMust = Number(data.Data.taskConfig.IsMust);
          console.log(data.Data.taskConfig, "ruleForm.isMust");
          this.ruleForm.remark = data.Data.taskConfig.Remark;
          if (this.ruleForm.isIndate == 1) {
            this.viewTime[0] = this.$moment(
              data.Data.taskConfig.BeginTime
            ).format("YYYY-MM-DD HH:mm");
            this.viewTime[1] = this.$moment(
              data.Data.taskConfig.EndTime
            ).format("YYYY-MM-DD HH:mm");
          }

          this.examineeData = data.Data.stuArr;
          // .map((item) => {
          //   for (let ztiem in item) {
          //     if (item[ztiem] === "" || item[ztiem] === null) {
          //       item[ztiem] = "未设置";
          //     }
          //   }
          //   item.Birthday1 = this.$moment(item.BeginTime).format(
          //     "YYYY/MM/DD HH:mm"
          //   );
          //   item.JobDate = this.$moment(item.JobDate).format(
          //     "YYYY/MM/DD HH:mm"
          //   );
          //   return item;
          // });
          this.list_vip = JSON.parse(JSON.stringify(this.examineeData));
          this.videoArr = data.Data.videoArr.map((item) => {
            item.id = item.VideoID; // VideoID就是id
            item.summary = item.VideoName
            item.type = item.Type
            item.bookID = item.BookID
            return item;
          });
          this.editType = true;
        } else {
          this.$message.error(data.Data);
        }
      }
    },
    previousStep(type, formName) {
      if (type == 0) {
        // 上一步
        if (this.active == 0) {
          // 取消
          this.backBtn();
        } else if (this.active == 1) {
          this.videoArr = this.$refs.cascade.multipleSelection;
        }
        this.active--;
      } else {
        // 下一步
        let state = 0;
        if (this.active == 0) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              // alert("submit!");
            } else {
              state = 1;
              console.log("error submit!!");
              return false;
            }
          });
        } else if (this.active == 1) {
          this.videoArr = this.$refs.cascade.multipleSelection;
          state = this.videoArr.length > 0 ? 0 : 1;
        } else if (this.active == 2) {
          // 提交
          this.examineeData = this.$refs.candidate.getData;
          // .map((item) => {
          //   return item.UserID;
          // }); // 勾中考生
          console.log(this.$refs.candidate.list_vip, "list_vip");
          console.log(this.$refs.candidate.getData);

          if (this.examineeData.length > 0) {
            this.addVideoTask();
          } else {
            this.$message({
              message: "警告，请选择考生",
              type: "warning",
            });
          }
        }
        if (this.active == 2) {
          return;
        } else if (state == 0) {
          this.active++;
        } else {
          this.$message({
            message: `警告，请${this.active == 0 ? "请填写信息" : "选择视频"}`,
            type: "warning",
          });
        }
      }
    },
    // 提交添加
    async addVideoTask() {
      this.loading = true;
      let arr = this.videoArr.map((item) => {
        const obj = {
          VideoName: item.summary,
          VideoID: item.id,
          Type: item.type,
          BookID: item.bookID,
          AppID: item.AppID,
          // id: item.id,
        };
        return obj;
      });
      // arr = arr.filter(item=>{
      //   if (item.VideoName && item.VideoID) {
      //     return item;
      //   }
      // })
      console.log(arr);
      
      const arr1 = this.examineeData.map((item) => {
        return item.UserID;
      }); // 勾中考生
      const obj = {
        name: this.ruleForm.name,
        intro: this.ruleForm.intro, // 简介
        isMust: this.ruleForm.isMust, // 是否必须
        isIndate: this.ruleForm.isIndate, // 是否设置有效期（1是，0否）为1 时需要传beginTime和endTime
        remark: this.ruleForm.remark, // 备注
        videoArr: JSON.stringify(arr), // 视频
        studentIdArr: JSON.stringify(arr1), // 考生
      };
      if (this.ruleForm.isIndate == 1) {
        const time = JSON.parse(JSON.stringify(this.viewTime));
        obj.beginTime = this.$moment(time[0]).format("YYYY-MM-DD HH:mm:ss");
        obj.endTime = this.$moment(time[1]).format("YYYY-MM-DD HH:mm:ss");
      }
      console.log(obj);
      if (this.$parent.stateType == 0) {
        // 添加
        const { data } = await taskApi.addTask(obj);
        if (data.Status == 200) {
          setTimeout(() => {
            this.loading = false;
          }, 500);
          this.$message({
            message: `恭喜你，视频任务“${this.ruleForm.name}”新建成功`,
            type: "success",
          });
          this.cutcoms(0);
        } else {
          this.$message.error(data.Data);
        }
      } else {
        // 编辑
        obj.taskID = this.$parent.rowObj.taskId;
        const { data } = await taskApi.editTask(obj);
        if (data.Status == 200) {
          setTimeout(() => {
            this.loading = false;
          }, 500);
          this.$message({
            message: `恭喜你，视频任务“${this.ruleForm.name}”编辑成功`,
            type: "success",
          });
          this.cutcoms(0);
        } else {
          this.$message.error(data.Data);
        }
      }
    },
  },
  computed: {
    titleText() {
      return function () {
        // 考场关闭且有人在考场禁用
        if (this.active == 0) {
          return "任务信息";
        } else if (this.active == 1) {
          return "选择视频";
        } else if (this.active == 2) {
          return "选择学员";
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.mian_view {
  // height: 100%;
  width: 100%;
  min-height: 780px;
  padding-bottom: 46px;
  // padding: 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}
// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  border-radius: 0px 0px 10px 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.main {
  padding: 24px;
  h3 {
    font-size: 22px;
  }
  .progress {
    height: 120px;
    padding: 0px 12%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e3e6eb;
    .progress_item {
      width: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
      > div {
        width: 30px;
        height: 30px;
        line-height: 30px;
        background: #bbd3fb;
        color: #fff;
        border-radius: 50%;
        text-align: center;
      }
    }
    .divider {
      width: 40%;
      height: 2px;
      background: #0052d9;
    }
  }
}
.selected {
  background: #0000ff !important;
}
.title {
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  > div {
    width: 40%;
    margin-left: 24px;
    border-bottom: 1px solid #e3e6eb;
  }
}
.task_info {
  display: flex;
  justify-content: center;
  align-items: center;
  ::v-deep .el-form {
    width: 50%;
    //  border: 1px solid #000;
    .el-input__inner {
      width: 320px;
    }
    .el-textarea__inner {
      height: 140px;
    }
    .el-textarea {
      width: 520px;
    }
  }
}
.button_view {
  // width: 100%;
  flex: 0 0 110px;
  z-index: 999;
  border-top: 1px solid #eeeef0;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-button {
    width: 112px;
    height: 40px;
    background: #ebecf1;
    border-radius: 3px;
    &:nth-child(1) {
      margin-right: 20px;
    }
  }
}
.fixed {
  position: fixed;
  left: 50%;
  bottom: 5%;
  transform: translate(-5%, -5%);
  border-top: none !important;
}
.time_view {
  display: flex;
  flex-direction: column;
  .el-radio-group {
    margin-top: 2%;
  }
  ::v-deep .el-date-editor {
    width: 400px !important;
    margin-top: 24px;
  }
  ::v-deep .el-range-separator {
    width: 50px;
  }
}
.t {
  color: #aaaabd;
}
</style>